export default __webpack_public_path__ + "static/media/grafema_ss-wedding-identity_11.5cba7b7c.jpg";